import React from 'react';
import { Reveal } from './Reveal';
import { CountdownTimer } from './CountdownTimer';
import { PriceBlock } from './PriceBlock';
import { PRICE_TODAY } from '../constants/data';
export function FinalCTA() {
  return <section className="w-full px-5 py-16 sm:py-24" style={{
    background: 'linear-gradient(180deg, #0A0A0A 0%, #0A2010 100%)'
  }} data-id="element-128">
      <div className="mx-auto max-w-3xl text-center" data-id="element-129">
        <Reveal data-id="element-130">
          <h2 className="text-2xl sm:text-3xl lg:text-4xl font-extrabold leading-snug" data-id="element-131">
            El próximo mes podés seguir llegando a cero.
            <br data-id="element-132" />
            <span style={{
            color: '#00C853'
          }} data-id="element-133">
              O podés tener el sistema funcionando desde hoy.
            </span>
          </h2>
        </Reveal>

        <div className="mt-10" data-id="element-134">
          <CountdownTimer data-id="element-135" />
        </div>

        <Reveal delay={0.1} data-id="element-136">
          <div className="mt-12" data-id="element-137">
            <PriceBlock ctaLabel={`QUIERO MI MEGAPACK — ${PRICE_TODAY}`} data-id="element-138" />
          </div>
        </Reveal>
      </div>
    </section>;
}